




























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class RatingInput extends Vue {
  @Prop() readonly?: boolean;
  @Prop() disabled?: boolean;
  @Prop() value?: number;
  @Prop({ default: "" }) label?: string;
  @Prop({ default: () => [] }) rules?: ((val: any) => boolean | any)[];
  @Prop({ default: false }) dense?: boolean;

  error = false;

  change(val: number) {
    this.$emit("input", val)
  }
}
